import React, { useEffect, useState } from 'react';
import { useForm ,Controller} from 'react-hook-form';
import Axios from 'axios';
import LoadingSpinner from '../helpers/loadingspinner';
import { Link, useLocation,useNavigate } from 'react-router-dom';
import {
  GetJobRoles,
   HRinitialScreening,
  UpdateInterviewCandidateByID,
  GetTestTypes,
  GetJobPosts
} from '../apiconstants/constants';
import Swal from 'sweetalert2';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Select from 'react-select';
import WYSIWYGEditor from "../helpers/WYSIWYGEditor";
import { useCountry } from "../contexts/countrycodecontext.js";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const EditScreeningTest = () => {
  const { register, handleSubmit, formState: { errors, isSubmitting },watch, setValue, reset, control} = useForm({
  defaultValues: {
    isVideoRequired: "True",
    isCustomQuestionsRequired: "False",
  },
});
  let query = useQuery();
  const candidateguid = query.get('guid');
  const queryemail = query.get('email');
  const queryTestType = query.get('test');
  const navigate= useNavigate()
  const [isDisabled, setIsDisabled] = useState(false);
  const [jobRoles, setJobRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedJobRoleId, setSelectedJobRoleId] = useState("");
  const [selectedTestTypeId, setSelectedTestTypeId] = useState("");
  const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [jobRole, setJobRole] = useState();
    const [duration,setDuration] = useState([
      {durationID:"5",durationValue:"5"},
      {durationID:"10",durationValue:"10"},
      {durationID:"15",durationValue:"15"},
      {durationID:"20",durationValue:"20"},
      {durationID:"25",durationValue:"25"},
      {durationID:"30",durationValue:"30"}])
      const [questions,setQuestions] = useState([
        {questionID:"1",questionValue:"1"},
        {questionID:"2",questionValue:"2"},
        {questionID:"3",questionValue:"3"},
        {questionID:"4",questionValue:"4"},
        {questionID:"5",questionValue:"5"},
        {questionID:"6",questionValue:"6"},
        {questionID:"7",questionValue:"7"},
        {questionID:"8",questionValue:"8"},
        {questionID:"9",questionValue:"9"},
        {questionID:"10",questionValue:"10"}])
      const [testTypes, setTestTypes] = useState([]);
   const [jobPosts, setJobPosts] = useState([]);
      
      let Guid="";
      const guid = localStorage.getItem("guid");
      const employerGuid = localStorage.getItem("employerGuid")
      const { selectedCountry} = useCountry();
      const token = localStorage.getItem("jwtToken");
      const roleID = localStorage.getItem("roleID")
      
      if(roleID==3){
       Guid = employerGuid
      }
      else{
        Guid= guid
      } 
  const fetchJobRoles = async () => {
    const GetapiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
    const response = await fetch(GetapiUrl);
    const json = await response.json();
    setJobRoles(json);
  };

  const jobRoleOptions = jobRoles.map((item) => ({
    value: item.jobRoleId,
    label: item.jobRole
  }));
  
        const fetchJobPosts = async () => {
              setIsLoading(true);
              try {
                  const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                  );
                 const filteredJobPosts = response.data?.filter((x)=>x.status=='Active')
                setJobPosts(filteredJobPosts);
                  setIsLoading(false);
              } catch (error) {
                  console.error("Error fetching job posts", error);
                  setIsLoading(false);
              }
          };
  

  const fetchTestTypes = () => {
  Axios.get(GetTestTypes.APIURL,{headers: { Authorization: `Bearer ${token}` } }).then((response) => {
        setTestTypes(response.data);
    }).catch((error) => {
        console.error("Error fetching test types", error);
    });
};

 const useremail = localStorage.getItem("email")
  const getInterviewDetails = async () => {
    setIsLoading(true);
    const GetapiUrl = `${HRinitialScreening.APIURL}/${candidateguid}`;
    try {
      const result = await Axios.get(GetapiUrl);
      const interviewData = await result.data[0];
      setData(interviewData);
      setName(interviewData.name);
      setEmail(interviewData.email);
      setJobRole(interviewData.technology)
      // Find the job role ID that matches the technology
      const matchedJobRole = jobRoles.find(role => role.jobRole === interviewData.technology);
      setSelectedJobRoleId(matchedJobRole ? matchedJobRole.jobRoleId : "");

      setValue('JobRole', matchedJobRole ? matchedJobRole.jobRoleId : "");
      setValue('testTypeID', queryTestType ? queryTestType : "");
      setSelectedTestTypeId(queryTestType)
      setValue('startDate', interviewData.startDate.split('T')[0]);
      setValue('endDate', interviewData.endDate.split('T')[0]);
      setValue('time', interviewData.time);
      setValue('questionsCount', interviewData.questionsCount);
      setValue('jobDescription', interviewData.jobDescription);
      setValue('isVideoRequired', interviewData.isVideoRequired ? "True" : "False");
      setValue('isCustomQuestionsRequired', interviewData.isCustomQuestionsRequired ? "True" : "False");
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching interview details', error);
      setIsLoading(false);
    }
  };

  // const testTypeName = testTypes.find((type) => type.testTypeID == queryTestType)?.testType || "Unknown Test Type";
  


  const onSubmit = async (formData, e) => {
    console.log(formData)
    e.preventDefault();
    setIsLoading(true);
    const params = {
      email:queryemail,
      jobRoleID: parseInt(formData.JobRole),
      guiID: candidateguid,
      testTypeID: Number(selectedTestTypeId),
      startDate: formData.startDate,
      endDate: formData.endDate,
      time:Number(formData.time),
      questionsCount:formData.questionsCount,
      "updatedBy": useremail,
      logolink:null,
      companyName: null,
      employerGuid:Guid,
      jobDescription : formData.jobDescription,
      isVideoRequired: JSON.parse(formData.isVideoRequired.toLowerCase()),
      iscustomQuestionsRequired: JSON.parse(formData?.isCustomQuestionsRequired.toLowerCase()),

    };
    const apiUrl = UpdateInterviewCandidateByID.APIURL;
    try {
      const result = await Axios.post(apiUrl, params,{  
        headers: { Authorization: `Bearer ${token}` }
     } );
      setIsLoading(false);
      if (result.data === 'Job seekers added successfully') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Updated Test Successfully',
          showConfirmButton: false,
          timer: 5000,
        });
        navigate("/Employer/GetInterviewScheduledCandidates")
      } else if(result.data === 'No Questions') {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Please add questions before configuring test for this Role',
          showConfirmButton: false,
          timer: 5000,
        });
      }
      else if(result.data === 'Updated successfully') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Updated Test Successfully',
          showConfirmButton: false,
          timer: 5000,
        });
        navigate("/Employer/GetInterviewScheduledCandidates")

      }
    } catch (error) {
      console.error('Error updating data', error);
      setIsLoading(false);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error updating data',
        showConfirmButton: false,
        timer: 5000,
      });
    }
  };

      const jobPostOptions = jobPosts.map(job => ({
         label: `${job.title} - ${job.clientName}`,
          value: job.jobPostID,
          jobDescription: job.jobDescription // Store job description for later use
        }));
        
  
        useEffect(() => {
          if (selectedJobRoleId) {
            // Find job posts matching the selected job role
            const filteredJobs = jobPosts.filter(job => job.jobRoleID == selectedJobRoleId);
        
            if (filteredJobs.length > 0) {
              setValue("jobPost", filteredJobs[0].jobPostID); // Set Job Post dropdown
              setValue("jobDescription", filteredJobs[0].jobDescription); // Set Job Description
            } else {
              setValue("jobPost", ""); // Reset if no match
              setValue("jobDescription", "");
            }
          }
        }, [selectedJobRoleId, jobPosts, setValue]);
        
        

  useEffect(() => {
    fetchJobRoles();
    fetchTestTypes();
    fetchJobPosts();
  }, [selectedCountry]);

  useEffect(() => {
    if (jobRoles.length > 0) {
      getInterviewDetails();
    }
  }, [jobRoles]);



  return (
    <ConsultantLayout>
      <section>
        {isLoading ? (
          <center>
            <LoadingSpinner />
          </center>
        ) : (
          <div className="container-fluid mt-4 pb-5">
                                           <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/GetInterviewScheduledCandidates">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Edit Screening Test</h2>
</div> 
            <hr />
            <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
                        <div className="col-sm-12 col-lg-12 col-xl-12 col-md-12">
                        <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-fullName">Full Name</Tooltip>}>

<p><i className="fa fa-user icons"></i> {name}</p>
</OverlayTrigger>
<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-fullName">Email</Tooltip>}>
        <p><i className="fa fa-envelope icons"></i> {email}</p> 
        </OverlayTrigger>
        
         {/* <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-fullName">Test Type</Tooltip>}>
       <p><i className="fa fa-envelope icons"></i> {(testTypeName)}</p> 
        </OverlayTrigger>  */}
                        </div>
                       
                    {/* <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-fullName">Job Role</Tooltip>}>
                    <p><i className="fa fa-cogs icons"></i> {jobRole}</p> 
              </OverlayTrigger> */}
              <form onSubmit={handleSubmit(onSubmit)} id="loginform">
                <div className="row p-3">
                 
                  <div className="col-sm-12 col-xl-12 col-lg-12 col-md-12">
               
  <div className="mt-3">
    <Controller
      name="JobRole"
      control={control}
      rules={{ required: "Job Role is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={jobRoleOptions}
          value={jobRoleOptions.find(option => option.value == selectedJobRoleId)} 
          onChange={(selectedOption) => {
            field.onChange(selectedOption.value); // Store jobRoleId in form
            setSelectedJobRoleId(selectedOption.value); // Update local state
          }}

          placeholder="Select Job Role"
          className={`basic-form ${errors.JobRole ? 'is-invalid' : ''}`}
          styles={{
            control: (provided, state) => ({
              ...provided,
              height: 50,
              borderRadius: 15,
              borderColor: errors.JobRole ? 'red' : provided.borderColor
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 9999, // Ensures dropdown appears above everything
              position: "absolute" // Fixes layout issues
            })
          }}
        />
      )}
    />
    {errors.JobRole && (
      <div className="invalid-feedback d-block">{errors.JobRole.message}</div>
    )}
  </div>

<OverlayTrigger
  placement="bottom"
  overlay={(props) => <Tooltip id="tooltip" {...props}>Select Job Post</Tooltip>}
>
  <div className="mt-4">
    <Controller
      name="jobPost"
      control={control}
      // rules={{ required: "Job Post is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={jobPostOptions}
          placeholder="Select Job Post"
          className={`basic-form`}
          styles={{
            control: (provided) => ({
              ...provided,
              height: 50,
              borderRadius: 15,
              // borderColor: errors.jobPost ? 'red' : provided.borderColor
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 9999, // Ensures dropdown appears above everything
              position: "absolute" // Fixes layout issues
            })
          }}
         
      
          // Store the entire selected option object
          onChange={(selectedOption) => {
            field.onChange(selectedOption); // Save the full selected option
            setValue("jobDescription", selectedOption.jobDescription); // Set job description
          }}
          value={jobPostOptions.find(option => option.value === field.value)}
        />
      )}
    />
  </div>
</OverlayTrigger>


  <label style={{color:"#00a7ac", marginTop:10}}>Job Description</label>
  <Controller
          control={control}
          name="jobDescription"
          rules={{
            required: { value: true, message: "Job Description Required" },
          }}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <div>
              <WYSIWYGEditor
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                ref={ref}
                inputExtraProps={{
                  required: true,
                }}
              />
              {errors.jobDescription && (
                <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                  {errors.jobDescription.message}
                </p>
              )}
            </div>
          )}
        />
                    <OverlayTrigger
                      placement="bottom"
                      overlay={(props) => (
                        <Tooltip id="tooltip" {...props}>
                          Select Test Type   
                        </Tooltip>
                      )}
                    >
                      <select
                        {...register('testTypeID', { required: 'Test Type Required' })}
                        className={`form-control basic-form mt-3 ${errors.testTypeID ? 'is-invalid' : ''}`}
                        style={{ height: 50, borderRadius: 15 }}
                        value={selectedTestTypeId}
                        onChange={(e) => setSelectedTestTypeId(e.target.value)}
                      >
                        <option value="">Select Test Type</option>
                        {testTypes.map((item, index) => (
                          <option key={index} value={item.testTypeID}>
                            {item.testType}
                          </option>
                        ))}
                      </select>
                    </OverlayTrigger>
                    <div className="invalid-feedback">
                      {errors.testTypeID?.message}
                    </div>

                    <OverlayTrigger
                      placement="bottom"
                      overlay={(props) => (
                        <Tooltip id="tooltip" {...props}>
                          Start date
                        </Tooltip>
                      )}
                    >
                      <input
                        type="date"
                        name="startDate"
                        {...register('startDate', { required: 'Start date required' })}
                        disabled={isDisabled}
                        className={`form-control basic-form mt-3 ${
                          errors.startDate ? 'is-invalid' : ''
                        }`}
                        placeholder="Start date"
                      />
                    </OverlayTrigger>
                    <div className="invalid-feedback">
                      {errors.startDate?.message}
                    </div>

                    <OverlayTrigger
                      placement="bottom"
                      overlay={(props) => (
                        <Tooltip id="tooltip" {...props}>
                          End date
                        </Tooltip>
                      )}
                    >
                      <input
                        type="date"
                        name="endDate"
                        {...register('endDate', { required: 'End date required' })}
                        disabled={isDisabled}
                        className={`form-control basic-form mt-3 ${
                          errors.endDate ? 'is-invalid' : ''
                        }`}
                        placeholder="End date"
                      />
                    </OverlayTrigger>
                    <div className="invalid-feedback">
                      {errors.endDate?.message}
                    </div>

                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Number of Questions</Tooltip>)}>    

<select  {...register("questionsCount", { required: "Question Count Required" })} className={`form-control basic-form mt-3 ${errors.questionsCount ? 'is-invalid' : ''}`} style={{height:50,borderRadius:15}}  >
<option value="">Select Number of Questions </option>
{
questions.map((item,index)=>
{
return(

<option key={index}  value={item.questionValue}>{item.questionValue}</option>

);
}

)
}
</select>
</OverlayTrigger>
{ <div className="invalid-feedback">{errors.questionsCount?.message}</div> }
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Duration</Tooltip>)}>    

<select  {...register("time", { required: "Duration Required" })} className={`form-control basic-form mt-3 ${errors.time ? 'is-invalid' : ''}`} style={{height:50,borderRadius:15}}  >
<option value="">Select Time Duration </option>
{
duration.map((item,index)=>
{
return(

<option key={index}  value={item.durationValue}>{item.durationValue}</option>

);
}

)
}
</select>
</OverlayTrigger>
{ <div className="invalid-feedback">{errors.time?.message}</div> }
<div>
  <label className="mt-3 mr-3" style={{ color: "#00a7ac" }}>
    Video Required
  </label>

  <input
    {...register("isVideoRequired", { required: true })}
    type="radio"
    name="isVideoRequired"
    value="True"
    id="field-true"
    disabled={isDisabled}
  />
  <label style={{ fontSize: 13, color: "#495057", marginRight: 24, marginLeft: 6 }}>
    Yes
  </label>

  <input
    {...register("isVideoRequired", { required: true })}
    type="radio"
    name="isVideoRequired"
    value="False"
    id="field-false"
    disabled={isDisabled}
  />
  <label style={{ fontSize: 13, color: "#495057", marginLeft: 6 }}>
    No
  </label>

  {errors.isVideoRequired && (
    <div style={{ color: "#dc3545", fontSize: "80%" }}>
      Select Yes or No
    </div>
  )}
     <div>
  <label className="mt-3 mr-3" style={{ color: "#00a7ac" }}>Custom Questions Required?</label>
  
  <input 
    {...register("isCustomQuestionsRequired", { required: true })} // Fixed casing
    type="radio"
    name="isCustomQuestionsRequired"
    value="True"
    id="field-question-true" // Unique ID
    disabled={isDisabled}
  /> 
  <label style={{ fontSize: 13, color: "#495057", marginRight: 24, marginLeft: 6 }}>Yes</label>

  <input  
    {...register("isCustomQuestionsRequired", { required: true })}
    type="radio"
    name="isCustomQuestionsRequired"
    value="False"
    id="field-question-false" // Unique ID
    disabled={isDisabled}
  />
  <label style={{ fontSize: 13, color: "#495057", marginLeft: 6 }}>No</label>

  {errors.isCustomQuestionsRequired && <div style={{ color: "#dc3545", fontSize: "80%" }}>Select Yes or No</div>}
</div>
</div>

                 <Link to="/Employer/GetInterviewScheduledCandidates">  <button style={{ float: "right" }} disabled={isSubmitting || isDisabled} className="btn btn-primary mt-5">
                        Cancel
                      </button>
                      </Link>
                <button
                  id="svbutton"
                  style={{ float: 'right' }}
                  disabled={isSubmitting || isDisabled}
                  className="btn btn-primary pf-save mb-3 mr-3 mt-5"
                >
                  {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                  Configure Test
                </button>
                  </div>
                </div>

              
             
              </form>
            </div>
            </div>
          </div>
        )}
      </section>
    </ConsultantLayout>
  );
};

export default EditScreeningTest;
